import { slugify } from '@woolworthsnz/styleguide';
import { RecipeStampLocal } from '../models';
import { mealtimeSlug } from './mealtime.helper';

export function getRecipePath(
	mealTimes: RecipeStampLocal['mealTimes'],
	title: RecipeStampLocal['title'],
	recipeId: RecipeStampLocal['id']
): string {
	const mealtime = mealtimeSlug(mealTimes);
	const recipeSlugTitle = slugify(title);

	if (!mealtime || !recipeId || !recipeSlugTitle) {
		return `/recipes`;
	}

	return `/recipes/${mealtime}/${recipeId}/${recipeSlugTitle}`;
}
